import { useState } from "react"
import _ from "lodash"

// Components
import FormErrorMessage from "../../../Form/FormErrorMessage"
import CustomButton from "../../../../components/Buttons/CustomButton"

// Primereact
import { Card } from "primereact/card"

// Styles
import styles from "../../../../styles/Form.module.css"

export default function ErrorMessage({ formId, message, onCancel = () => {} }) {
  const [copied, setCopied] = useState(false)

  const handleCopyErrorInfo = () => {
    const text = [
      `Error code: ${formId} - FormId`,
      `Error message: ${message}`,
    ].join("\n")
    navigator?.clipboard?.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  const supportEmailSubject = `Submission error ${formId}`
  const supportEmailBody = [
    `Error code: ${formId}`,
    `Error message: ${message}`,
  ].join("\n")
  const supportEmailHref = `mailto:support@myrecoverylink.com?subject=${encodeURIComponent(
    supportEmailSubject,
  )}&body=${encodeURIComponent(supportEmailBody)}`

  return (
    <div className={styles.errorContainer}>
      <h2 className={styles.errorContainerHeader}>
        <span className="material-icons">error</span>
        Error processing data.
      </h2>

      <h3>
        <span className={styles.errorContainerSubHeader}>
          Form submission was not made,
        </span>
        {" but customer support can help!"}
      </h3>

      {formId && (
        <h3 className={styles.errorSupportMsg}>
          Please{" "}
          <a className={styles.errorSupportMsgLink} href={supportEmailHref}>
            contact customer support
          </a>{" "}
          and provide the following:
        </h3>
      )}

      <div className={styles.errorCardWrapper}>
        <button
          className={styles.copyButton}
          onClick={handleCopyErrorInfo}
          title="Copy error info"
          type="button"
        >
          <span className="material-icons">
            {copied ? "check" : "content_copy"}
          </span>
        </button>
        <Card>
          <div>
            Error code: <code className={styles.errorCode}>{formId}</code>
          </div>
          <div>
            Error message:
            {!_.isEmpty(message) && <FormErrorMessage msg={message} />}
          </div>
        </Card>
      </div>

      <div className={styles.errorButtonContainer}>
        {/* COMING SOON: Option to resubmit the form after an error occurs. */}
        {/* <CustomButton
            label="Resubmit"
            severity="primary"
            onClick={resubmit}
            disabled={resubmitCount >= 1}
          /> */}
        <CustomButton
          label="Close"
          severity="primary"
          outlined
          onClick={onCancel}
        />
      </div>
    </div>
  )
}
